module.exports = __webpack_public_path__ + "img/Toss_KR.b240876d.png";